import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

export enum MixmindUniverse {
  Academy = "academy",
  Play = "play",
  Assist = "assist",
  None = "none",
}

interface UniverseContextValue {
  universe: MixmindUniverse;
  setUniverse: (u: MixmindUniverse) => void;
}

const UniverseContext = createContext<UniverseContextValue | undefined>(undefined);

export function UniverseProvider({ children }: { children: React.ReactNode }) {
  const [universe, setUniverseState] = useState<MixmindUniverse>(MixmindUniverse.None);
  const setUniverse = useCallback((u: MixmindUniverse) => setUniverseState(u), []);

  const value = useMemo(() => ({ universe, setUniverse }), [universe, setUniverse]);

  return <UniverseContext.Provider value={value}>{children}</UniverseContext.Provider>;
}

export function useUniverse() {
  const ctx = useContext(UniverseContext);
  if (!ctx) throw new Error("useUniverse must be used within UniverseProvider");
  return ctx;
}
